export default "__VITE_ASSET__BOTBlMPw__"